import { BaseSliceController } from '@Base/slices/slices.base';
import { PromoCodesUsageRequester } from '../Services/PromoCodesUsage.req';
import { PromoCodesUsage } from '../Types/PromoCodes.types';

export class PromoCodesUsageSlice extends BaseSliceController<
	PromoCodesUsage,
	'PromoCodesUsage'
> {
	private static instance: PromoCodesUsageSlice;
	static getInstance() {
		if (!PromoCodesUsageSlice.instance) {
			PromoCodesUsageSlice.instance = new PromoCodesUsageSlice();
		}
		return PromoCodesUsageSlice.instance;
	}
	constructor() {
		super('PromoCodesUsage', PromoCodesUsageRequester.getInstance());
	}
}

export const { promoCodesUsageGetAll } =
	PromoCodesUsageSlice.getInstance().getActions();
